export default "__VITE_ASSET__8tbLUnzJ__"